import _ModalProvider from "choerodon-ui/pro/lib/modal-provider";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _ModalContainer from "choerodon-ui/pro/lib/modal-container";
import _get from "lodash/get";
import React, { useEffect, useMemo, useState } from 'react';
import { routerRedux, Switch, Route, withRouter } from 'dva/router';
import { getConfig } from 'hzero-boot';
import ModalContainer, { registerContainer } from "./components/Modal/ModalContainer";
import Authorized from "./components/Authorized/WrapAuthorized";
import PermissionProvider from "./components/Permission/PermissionProvider";
import HistoryProvider from "./components/HistoryLog/HistoryProvider";
import UedThemeConfig from "./components/UedThemeConfig";
import LocalProviderAsync from "./utils/intl/LocaleProviderAsync";
import { dynamicWrapper } from "./utils/router";
import { inject } from 'what-di';
import DefaultContainer from "./utils/iocUtils/DefaultContainer";
import { initIoc, getEnvConfig } from "./utils/iocUtils";
import { UedProvider } from "./utils/iocUtils/UedProvider";
import ThemeContext from '@hzero-front-ui/core/lib/utils/ThemeContext';
import { watermark, cacWaterMark } from "./utils/watermark";
import { getCurrentUser, getCurrentTimeZoneDate } from "./utils/utils"; // 初始化ioc容器

initIoc();
(function () {
  var ued = inject(UedProvider);
  ued.state.initFunction();
})(); // 水印配置

function initWaterMark() {
  var f = function f() {
    var container = document.querySelector(".ant-tabs[class*='index_menu-tabs']>.ant-tabs-content");
    if (!container) {
      setTimeout(f, 300);
      return;
    }
    var oldWater = container.querySelectorAll('.mask_mark');
    var config = cacWaterMark(container);
    var newMaskNums = config.watermark_cols * config.watermark_rows;
    if (newMaskNums === oldWater.length) {
      setTimeout(f, 300);
      return;
    }
    var currentUser = getCurrentUser();
    var waterMarkFlag = currentUser.waterMarkFlag,
      _currentUser$waterMar = currentUser.waterMarkRule,
      waterMarkRule = _currentUser$waterMar === void 0 ? '${loginName}-${realName}-${__CURRENT_DATE__}' : _currentUser$waterMar;
    if (oldWater.length > 0) {
      oldWater.forEach(function (node) {
        container.removeChild(node);
      });
    }
    if (waterMarkFlag) {
      var str = waterMarkRule.replace(/\$\{([^\f\n\r\t\v}{])*\}/g, function (item) {
        var temp = item === null || item === void 0 ? void 0 : item.substring(2, item.length - 1);
        if (temp !== '__CURRENT_DATE__') {
          return _get(currentUser, temp) || '';
        } else {
          return getCurrentTimeZoneDate().toLocaleDateString();
        }
      });
      watermark(str, config, container);
    }
    setTimeout(f, 300);
  };
  setTimeout(f, 300);
}
initWaterMark();
var WithRouterC7nModalContainer = withRouter(_ModalContainer);
var ConnectedRouter = routerRedux.ConnectedRouter;
var DefaultAuthorizedRoute = Authorized.DefaultAuthorizedRoute,
  PubAuthorizedRoute = Authorized.PubAuthorizedRoute;
function RouterConfig(_ref) {
  var history = _ref.history,
    app = _ref.app;
  var _useState = useState({
      Container: DefaultContainer
    }),
    _useState2 = _slicedToArray(_useState, 2),
    uedConfig = _useState2[0],
    setUedConfig = _useState2[1];
  var Layout = dynamicWrapper(app, [{
    namespace: 'user',
    loader: function loader() {
      return import("./models/user");
    }
  }, {
    namespace: 'login',
    loader: function loader() {
      return import("./models/login");
    }
  }], function () {
    return import("./layouts/Layout");
  });
  var PubLayout = dynamicWrapper(app, [{
    namespace: 'user',
    loader: function loader() {
      return import("./models/user");
    }
  }, {
    namespace: 'login',
    loader: function loader() {
      return import("./models/login");
    }
  }], function () {
    return import("./layouts/PubLayout");
  }); // 免登陆无权限路由

  var PublicLayout = dynamicWrapper(app, [], function () {
    return import("./layouts/PublicLayout");
  }); // 免登陆权限路由

  var PrivateLayout = dynamicWrapper(app, [], function () {
    return import("./layouts/PrivateLayout");
  });
  useEffect(function () {
    var ued = inject(UedProvider);
    ued.subscribe(function (_ref2) {
      var _ref2$Container = _ref2.Container,
        Container = _ref2$Container === void 0 ? null : _ref2$Container;
      setUedConfig({
        Container: Container || DefaultContainer
      });
    });
  }, []); // 页面布局中的head

  var layoutExtraHeader = useMemo(function () {
    return getConfig('layoutExtraHeader');
  }, []);
  var redirectData = useMemo(function () {
    var result = getConfig('redirectData');
    if (typeof result === 'function') {
      return result();
    }
    return result;
  }, []);
  var _getEnvConfig = getEnvConfig(),
    configureParams = _getEnvConfig.configureParams;
  var defaultTheme = (configureParams === null || configureParams === void 0 ? void 0 : configureParams.defaultTheme) || 'nightingale';
  return /*#__PURE__*/React.createElement(uedConfig.Container, {
    defaultTheme: defaultTheme
  }, /*#__PURE__*/React.createElement(LocalProviderAsync, null, /*#__PURE__*/React.createElement(PermissionProvider, null, /*#__PURE__*/React.createElement(HistoryProvider, null, /*#__PURE__*/React.createElement(ConnectedRouter, {
    history: history
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (themeProps) {
    return /*#__PURE__*/React.createElement(UedThemeConfig, {
      setTheme: themeProps.setTheme,
      schema: themeProps.schema
    });
  }), /*#__PURE__*/React.createElement(ModalContainer, {
    ref: registerContainer
  }), /*#__PURE__*/React.createElement(WithRouterC7nModalContainer, null), /*#__PURE__*/React.createElement(_ModalProvider, {
    location: location
  }), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/private",
    render: function render(props) {
      return /*#__PURE__*/React.createElement(PrivateLayout, Object.assign({
        redirectData: redirectData
      }, props));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/public",
    render: function render(props) {
      return /*#__PURE__*/React.createElement(PublicLayout, Object.assign({
        redirectData: redirectData
      }, props));
    }
  }), /*#__PURE__*/React.createElement(PubAuthorizedRoute, {
    path: "/pub",
    render: function render(props) {
      return /*#__PURE__*/React.createElement(PubLayout, Object.assign({
        redirectData: redirectData
      }, props));
    }
  }), /*#__PURE__*/React.createElement(DefaultAuthorizedRoute, {
    path: "/",
    render: function render(props) {
      return /*#__PURE__*/React.createElement(Layout, Object.assign({
        redirectData: redirectData
      }, props, {
        extraHeaderRight: layoutExtraHeader,
        headerProps: {
          toolbarProps: {
            extraHeaderRight: layoutExtraHeader
          }
        }
      }));
    }
  }))))))));
}
export default RouterConfig;